import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
interface GameHeaderProps {
  title?: string;
}
const GameHeader = ({ title }: GameHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Header>
      <Content>
        <Logo>
          <img src="/assets/images/icon/icon_trophy.svg" />
          {title}
        </Logo>
        <CloseBox
          onClick={() => {
            if (title) {
              navigate(-1);
            } else {
              navigate('/');
            }
          }}
        >
          <img src="/assets/images/icon/icon_game_close.svg" alt="close" />
        </CloseBox>
      </Content>
    </Header>
  );
};

export default GameHeader;

const Header = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid #e1e2e4;
`;
const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 68px;
`;
const CloseBox = styled.div`
  cursor: pointer;
  display: flex;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;
